import { render } from "./credentialComponent.vue?vue&type=template&id=f7c5f712"
import script from "./credentialComponent.vue?vue&type=script&lang=js"
export * from "./credentialComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__